<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.matRequireMonthPlan.new')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <!-- <li class="breadcrumb-item">
            <router-link to="/prd">
              <span>{{$t('tlt.production')}}</span>
            </router-link>
          </li> -->
          <li class="breadcrumb-item">
            <router-link to="/prd/matRequireMonthPlan">
              <span>{{$t('tlt.matRequireMonthPlan')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/matRequireMonthPlan/edit">
              <span>{{$t('tlt.matRequireMonthPlan.new')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="MMFbackToList('matRequireMonthPlan')"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('btn.basic.cancel')}}</span>
          </button>
          <button class="btn btn-primary" type="button" v-on:click="MMFSave('matRequireMonthPlan')">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <form>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <!-- <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.matRequireMonthPlan.code')}}:</label>
                                <input v-validate="'required'" name="description"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('code') }"
                                    v-model="code" type="text">
                                <span v-show="errors.has('code')" class="lbl-obg">
                                    {{ errors.first('code') }}
                                </span>
              </div>-->

              <div class="form-group col-md-2" style="display: none">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.matRequireMonthPlan.locId')}}:
                </label>
                <dimSearch
                  validate="required"
                  name="locId"
                  v-model="locId"
                  :entity="locations"
                  submitProp="id"
                  bindProp="id"
                  bindId="planLocation"
                ></dimSearch>
              </div>

              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.matRequireMonthPlan.locName')}}:
                </label>
                <dimSearch
                  validate="required"
                  name="locName"
                  v-model="locName"
                  :entity="locations"
                  submitProp="locName"
                  bindProp="locName"
                  bindId="planLocation"
                ></dimSearch>
              </div>

              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.matRequireMonthPlan.month')}}：
                </label>
                <mmf-monthpicker v-model="month"></mmf-monthpicker>
              </div>

              <div class="form-group col-md-2" style="display: none">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.matRequireMonthPlan.matId')}}:
                </label>
                <dimSearch
                  validate="required"
                  name="matId"
                  v-model="matId"
                  :entity="materials"
                  submitProp="id"
                  bindProp="id"
                  bindId="planMaterial"
                ></dimSearch>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.matRequireMonthPlan.matName')}}:
                </label>
                <dimSearch
                  validate="required"
                  name="matName"
                  v-model="matName"
                  :entity="materials"
                  submitProp="matName"
                  bindProp="matName"
                  bindId="planMaterial"
                ></dimSearch>
              </div>

              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.matRequireMonthPlan.quantity')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="quantity"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('quantity') }"
                  v-model="quantity"
                  type="text"
                />
                <span v-show="errors.has('quantity')" class="lbl-obg">{{ errors.first('quantity') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.matRequireMonthPlan.unit')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="unit"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('unit') }"
                  v-model="unit"
                  type="text"
                />
                <span v-show="errors.has('unit')" class="lbl-obg">{{ errors.first('unit') }}</span>
              </div>

              <!-- <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.matRequireMonthPlan.status')}}:</label>
                                <input class="form-control form-control-sm" v-model="status" type="text">
              </div>-->
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>



<script>
import { createHelpers } from "vuex-map-fields";
import { mapActions, mapState } from "vuex";
import { fields } from "@/model/prd/productionPlan/MatRequireMonthPlan";
import dimSearch from "@/components/MMFDimSearch";
import MmfMonthpicker from "@/components/MmfMonthpicker";

const { mapFields } = createHelpers({
  getterType: "matRequireMonthPlan/getField",
  mutationType: "matRequireMonthPlan/updateField"
});
export default {
  data() {
    return {};
  },
  beforeMount() {
    this.$store.dispatch("matRequireMonthPlan/loadLocations");
    this.$store.dispatch("matRequireMonthPlan/loadMaterials");
  },
  computed: {
    ...mapFields(fields),
    ...mapState({
      locations: state => state.matRequireMonthPlan.locations,
      materials: state => state.matRequireMonthPlan.materials
    })
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFSave"])
  },
  components: {
    dimSearch,
    MmfMonthpicker
  }
};
</script>